<mat-card class="large-card">
    <card-controller-panel
            [cardInfo]="cardControllerInfo"
    ></card-controller-panel>
    <div class="card-title-area">{{ simpleCard.title }}</div>
    <div
        class="card-data-area"
        *ngIf="simpleCard"
        [ngStyle]="{ cursor: simpleCard.hasAccess ? 'pointer' : '' }"
        (click)="dataCardClick(simpleCard)"
    >
        <div *ngIf="!simpleCard.isDataready" class="simple-table-card-sinner-area">
            <spin-loader [type]="'spinner'"> </spin-loader>
        </div>

        <div class="no-data-message-area" *ngIf="simpleCard.isDataready && !simpleCard.hasData">
            <no-data-screen [noDataType]="simpleCard.noDataType"> </no-data-screen>
        </div>

        <table *ngIf="simpleCard.isDataready && simpleCard.hasData">
            <thead>
                <tr>
                    <th [ngStyle]="head.style" *ngFor="let head of simpleCard.headerItems">
                        {{ head.value }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of simpleCard.rowItems">
                    <td [ngStyle]="dataItem.style" *ngFor="let dataItem of row">
                        <ng-container *ngIf="!simpleCard.showPercentages; else elseBlock">
                            {{ dataItem.value }}
                        </ng-container>
                        <ng-template #elseBlock>
                            <span
                                [ngStyle]="{
                                    width: dataItem.value.length > 5 ? '89px' : '58px',
                                    'text-align':
                                        dataItem.percent || dataItem.percent === 0
                                            ? 'right'
                                            : 'left'
                                }"
                                style="display: inline-block; padding-right: 5px"
                                >{{ dataItem.value }}
                            </span>
                            <span *ngIf="dataItem.percent || dataItem.percent === 0">/ </span>
                            <span
                                *ngIf="dataItem.percent || dataItem.percent === 0"
                                style="display: inline-block; width: 29px; text-align: right"
                                >{{ dataItem.percent }}%</span
                            >
                        </ng-template>
                    </td>
                </tr>
                <tr>
                    <td
                        [ngStyle]="footer.style"
                        class="bottom-row"
                        *ngFor="let footer of simpleCard.footerItems"
                    >
                        {{ footer.value }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</mat-card>
